import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  contentPadding: {
    padding: theme.spacings.md,
  },
  contentText: {
    fontSize: theme.fontSizes.xl,
  },
});
